import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PersistantStorageService {

  constructor() { }

  saveToSession<T>(key: string, value: T): void {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  getFromSession<T>(key: string): T | undefined {
    return sessionStorage.getItem(key) ? JSON.parse(sessionStorage.getItem(key) ?? '') as T : undefined;
  }
}
